import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-essentials-cover',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './essentials-cover.component.html',
  styleUrl: './essentials-cover.component.scss',
})
export class EssentialsCoverComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Essential Cover Travel Insurance | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover Essential Travel Insurance covers medical emergencies, lost luggage, cancellations and more, with protection for your next international trip.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Essential Cover Travel Insurance | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover Essential Travel Insurance covers medical emergencies, lost luggage, cancellations and more, with protection for your next international trip.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
